import { useV2UpdateAccountCallbackMutation } from "@generated";
import type { V2AccountCallbackResource } from "@generated";
import type { AccountCallbackFormValues } from "../types";

// The `account` linkage is server-side (the account_callbacks join), so we send
// only the redirect uri and cast, mirroring the other admin-kit MSPAs.
export const buildAccountCallbackData = (
  values: AccountCallbackFormValues,
  id: string
): V2AccountCallbackResource =>
  ({
    type: "account-callbacks",
    id,
    attributes: { "redirect-uri": values.redirectUri },
  } as unknown as V2AccountCallbackResource);

export const useAccountCallbackMutations = () => {
  const [update, updateState] = useV2UpdateAccountCallbackMutation();

  return {
    update: (id: string, values: AccountCallbackFormValues) =>
      update({
        id,
        body: { data: buildAccountCallbackData(values, id) },
      }).unwrap(),
    states: { updateState },
  };
};

export default useAccountCallbackMutations;
